import { render, staticRenderFns } from "./NewItem.vue?vue&type=template&id=d1e88aa2&scoped=true"
import script from "./NewItem.vue?vue&type=script&lang=js"
export * from "./NewItem.vue?vue&type=script&lang=js"
import style0 from "./NewItem.vue?vue&type=style&index=0&id=d1e88aa2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e88aa2",
  null
  
)

export default component.exports